/* ===========================================================================
   YEMAT — product page conversion fix
   Added 6 Oct 2026. Loaded from sections/global-menu.liquid.

   The product copy in Shopify is strong — fabric, construction, fit, care,
   and a "Good to know" block that answers the real objections (pullover or
   zip, is 450 GSM too warm, is a white tee see-through). The page was showing
   almost none of it. Measured on the Force Hoodie: 1,888 characters of
   visible text on a A$295 page, with 2,253 characters sitting inside
   accordions that all rendered closed, and the "Good to know" block not
   rendered at all.

   What this file does:
     1. Opens "Fit & size" by default. The accordion is one-at-a-time — the
        theme closes the others when one opens — so exactly one can start
        open, and sizing is the objection that stops an oversized-fit sale.
     2. Renders the "Good to know" block from the product's own description,
        as a matching accordion item, open by default.
     3. Renders the three selling points from custom.selling_points under the
        buy box. They were written per product and rendered nowhere.
     4. Makes Add to cart say "Select a size" until a size is chosen, on both
        the main button and the sticky bar, instead of erroring on tap.

   What it deliberately does NOT do: add shipping or exchange lines under
   Add to cart. Those already exist in ul.ymtp-rows — free express 2–4 days,
   free 14-day exchange, dispatched within 24 h. Do not add them again.

   This file changes none of the theme's own markup, and every step is
   wrapped so a failure leaves the page exactly as the theme rendered it.
   =========================================================================== */

(function () {
  'use strict';

  /* One only — the accordion is exclusive. */
  var OPEN_BY_DEFAULT = ['fit & size', 'fit and size'];

  function onProductPage() {
    return /\/products\/[^\/]+/.test(window.location.pathname);
  }

  function handle() {
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function text(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /* ---------- 1. open the accordion that answers the sizing question ----- */

  function openKeyAccordion() {
    var acc = document.querySelector('.ymtp-acc');
    if (!acc) return;
    var items = acc.querySelectorAll('details');
    for (var i = 0; i < items.length; i++) {
      if (OPEN_BY_DEFAULT.indexOf(text(items[i].querySelector('summary'))) !== -1) {
        items[i].open = true;
        return; /* opening a second would close this one */
      }
    }
  }

  /* ---------- 2. render the "Good to know" block ------------------------- */

  function sanitize(node) {
    node.querySelectorAll('script, style, iframe, object, embed, form').forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    node.querySelectorAll('*').forEach(function (n) {
      Array.prototype.slice.call(n.attributes || []).forEach(function (a) {
        if (/^on/i.test(a.name)) n.removeAttribute(a.name);
        if (a.name === 'href' && /^\s*javascript:/i.test(a.value)) n.removeAttribute('href');
      });
    });
    return node;
  }

  function extractGoodToKnow(descriptionHtml) {
    var box = document.createElement('div');
    box.innerHTML = descriptionHtml || '';
    sanitize(box);

    var kids = Array.prototype.slice.call(box.children);
    var start = -1;
    for (var i = 0; i < kids.length; i++) {
      if (/^h[1-6]$/i.test(kids[i].tagName) && /good to know/i.test(kids[i].textContent || '')) {
        start = i;
        break;
      }
    }
    if (start === -1) return null;

    var out = document.createElement('div');
    for (var j = start + 1; j < kids.length; j++) out.appendChild(kids[j].cloneNode(true));
    return out.children.length ? out : null;
  }

  function renderFaq() {
    var acc = document.querySelector('.ymtp-acc');
    if (!acc || acc.querySelector('[data-ymt-faq]')) return;

    var h = handle();
    if (!h) return;

    fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (product) {
        if (!product || !product.description) return;
        if (acc.querySelector('[data-ymt-faq]')) return;

        var body = extractGoodToKnow(product.description);
        if (!body) return;

        /* Built as a <details> inside the theme's own accordion container so it
           inherits the existing type, rules and spacing exactly. The open
           attribute is set BEFORE insertion, so the theme's one-at-a-time
           handler never fires and "Fit & size" stays open alongside it. */
        var model = acc.querySelector('details');
        var d = document.createElement('details');
        if (model && model.className) d.className = model.className;
        d.setAttribute('data-ymt-faq', '1');
        d.open = true;

        var s = document.createElement('summary');
        var modelSummary = model ? model.querySelector('summary') : null;
        if (modelSummary && modelSummary.className) s.className = modelSummary.className;
        s.textContent = 'Good to know';
        d.appendChild(s);

        var wrap = document.createElement('div');
        wrap.className = 'ymt-faq__body';
        wrap.appendChild(body);
        d.appendChild(wrap);

        acc.appendChild(d);
      })
      .catch(function () { /* leave the page exactly as the theme rendered it */ });
  }

  /* ---------- 3. product proof under the buy box ------------------------ */

  /* custom.selling_points holds three "Title|Body" lines per product, already
     written, and none of it was rendering anywhere. Emitted into window.YMT_PROOF
     by sections/global-menu.liquid and laid out here as plain type with rules —
     no icon row. Nothing is invented: if the metafield is empty, nothing renders. */

  function renderProof() {
    var raw = window.YMT_PROOF;
    if (!raw || typeof raw !== 'string') return;

    var rows = document.querySelector('ul.ymtp-rows');
    if (!rows || !rows.parentNode) return;
    if (document.querySelector('.ymt-proof')) return;

    var items = [];
    raw.split('\n').forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var i = line.indexOf('|');
      if (i === -1) return;
      var t = line.slice(0, i).trim();
      var b = line.slice(i + 1).trim();
      if (t && b) items.push({ t: t, b: b });
    });
    if (!items.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'ymt-proof';
    items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'ymt-proof__item';
      var t = document.createElement('span');
      t.className = 'ymt-proof__t';
      t.textContent = it.t;                 /* textContent, never innerHTML */
      var b = document.createElement('span');
      b.className = 'ymt-proof__b';
      b.textContent = it.b;
      row.appendChild(t);
      row.appendChild(b);
      wrap.appendChild(row);
    });
    rows.parentNode.insertBefore(wrap, rows.nextSibling);
  }

  /* ---------- 4. Add to cart reflects whether a size is chosen ----------- */

  /* The button previously read "Add to cart" even with nothing selected, and
     tapping it produced an error. The form's hidden input[name="id"] carries
     the variant id and is empty until a size is chosen — that is the single
     source of truth used here. If it cannot be read, nothing is intercepted
     and the theme behaves exactly as before. */

  var SELECT_LABEL = 'Select a size';
  var originalLabels = new WeakMap ? new WeakMap() : null;

  function sizeChosen() {
    var form = document.querySelector('.ymtp-form');
    if (!form) return null;                       /* unknown -> never intercept */
    var input = form.querySelector('input[name="id"]');
    if (!input) return null;                      /* unknown -> never intercept */
    var v = (input.value || '').trim();
    return !!(v && v !== '0');
  }

  function labelFor(btn, chosen) {
    if (originalLabels && !originalLabels.has(btn)) {
      originalLabels.set(btn, (btn.textContent || 'Add to cart').trim());
    }
    var original = originalLabels ? originalLabels.get(btn) : 'Add to cart';
    var wanted = chosen ? original : SELECT_LABEL;
    if (btn.textContent.trim() !== wanted) btn.textContent = wanted;
    btn.setAttribute('data-ymt-state', chosen ? 'ready' : 'needs-size');
  }

  function syncCta() {
    var chosen = sizeChosen();
    if (chosen === null) return;
    var main = document.querySelector('.ymtp-atc');
    var sticky = document.querySelector('.ymt-satc-b');
    if (main) labelFor(main, chosen);
    if (sticky) labelFor(sticky, chosen);
  }

  function nudgeToSizes() {
    var sizes = document.querySelector('.ymtp-sizes');
    if (!sizes) return;
    try { sizes.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { sizes.scrollIntoView(); }
    sizes.classList.add('ymt-sizes-flash');
    setTimeout(function () { sizes.classList.remove('ymt-sizes-flash'); }, 1400);
  }

  /* Capture phase, so this runs before the theme's own submit handler. It only
     ever stops the event when a size is definitely NOT chosen. */
  function guard(e) {
    if (sizeChosen() !== false) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    var opener = document.querySelector('.ymt-satc-s');
    if (this.className && this.className.indexOf('ymt-satc-b') !== -1 && opener) {
      opener.click();
      return;
    }
    nudgeToSizes();
  }

  function wireCta() {
    if (sizeChosen() === null) return;
    ['.ymtp-atc', '.ymt-satc-b'].forEach(function (sel) {
      var btn = document.querySelector(sel);
      if (!btn || btn.hasAttribute('data-ymt-wired')) return;
      btn.setAttribute('data-ymt-wired', '1');
      btn.addEventListener('click', guard, true);
    });
    syncCta();

    var form = document.querySelector('.ymtp-form');
    if (form) {
      form.addEventListener('change', function () { setTimeout(syncCta, 0); });
      form.addEventListener('input', function () { setTimeout(syncCta, 0); });
    }
    /* Size spans are not inputs, so also re-check shortly after any tap on
       the size row or the sticky size opener. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.ymtp-sizes, .ymt-satc-s, .ymtp-sizehead')) {
        setTimeout(syncCta, 60);
        setTimeout(syncCta, 400);
      }
    }, true);
  }

  /* ---------- boot ------------------------------------------------------- */

  /* The buy box is rendered client-side, so .ymtp-form does not exist at
     DOMContentLoaded. Wait for it rather than running against an empty page,
     and re-apply if the theme re-renders the form on variant change. */
  function whenBuyBoxReady(cb) {
    var tries = 0;
    (function attempt() {
      if (document.querySelector('.ymtp-form') && document.querySelector('.ymtp-atc')) { cb(); return; }
      if (++tries > 60) { cb(); return; } /* give up waiting; every step no-ops safely */
      setTimeout(attempt, 150);
    })();
  }

  function apply() {
    try { openKeyAccordion(); } catch (e) {}
    try { wireCta(); } catch (e) {}
    try { renderProof(); } catch (e) {}
    try { renderFaq(); } catch (e) {}
  }

  function boot() {
    if (!onProductPage()) return;
    whenBuyBoxReady(function () {
      apply();

      if (typeof MutationObserver !== 'function') return;
      var t = null, count = 0, windowStart = Date.now();
      var mo = new MutationObserver(function () {
        var now = Date.now();
        if (now - windowStart > 1000) { windowStart = now; count = 0; }
        if (++count > 40) { mo.disconnect(); return; }
        if (t) clearTimeout(t);
        t = setTimeout(function () {
          t = null;
          try { wireCta(); } catch (e) {}  /* idempotent: data-ymt-wired guards it */
          try { syncCta(); } catch (e) {}
        }, 120);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();